"use client";

import ReactDOM from "react-dom";
export function PreloadImage({
  resources
}: {
  resources: string[];
}) {
  resources.forEach(resource => {
    ReactDOM.preload(resource, {
      as: "image",
      fetchPriority: "high"
    });
  });
  return null;
}